import React, { FunctionComponent, HTMLAttributes } from "react";
import cx from "classnames";
/** Load css/stylus  */
import "./HorizontalSpliiter.styl";

/**
 * 정의된 프로퍼티/상태 없음. 기본 DIV Attribute는 전달
 *
 * @interface ISplitterProps    { Nothing }
 * @extends {HTMLAttributes<HTMLDivElement>}
 */
interface ISplitterProps extends HTMLAttributes<HTMLDivElement> {}

/**
 * 수평 구분자 UI
 *
 * @param {*} {}
 */
const HorizontalSpliiter: React.FunctionComponent<{
  ISplitterProps: any;
}> = props => {
  /**
   * @method handleContextMenu
   * @description 우측마우스 클릭시, 기본 Context 표시를 막는다.
   * @param {React.MouseEvent<HTMLDivElement>} e
   */
  const handleContextMenu = function(e: React.MouseEvent<HTMLDivElement>) {
    // 우측 마우스를 눌렀을때, 발생하는 기본 동작을 막는다.
    e.preventDefault();
  };
  return (
    <div
      className={cx("HorizontalSpliiter", "noselect", "nodrag")}
      {...props}
      onContextMenu={handleContextMenu}
    />
  );
};

export default HorizontalSpliiter;
